export type AssetMetadata =
  | { content_type: string; [key: string]: any }
  | { contentType: string; [key: string]: any };

const getContentType = (metadata: AssetMetadata): string =>
  (metadata as any).content_type ?? (metadata as any).contentType ?? "";

// Document/presentation content types that expose per-page analytics.
export const hasPageAnalytics = (metadata: AssetMetadata): boolean => {
  switch (getContentType(metadata)) {
    case "application/pdf":
    case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
    case "application/vnd.openxmlformats-officedocument.presentationml.template":
    case "application/vnd.openxmlformats-officedocument.presentationml.slideshow":
    case "application/vnd.ms-powerpoint.addin.macroEnabled.12":
    case "application/vnd.ms-powerpoint.presentation.macroEnabled.12":
    case "application/vnd.ms-powerpoint.template.macroEnabled.12":
    case "application/vnd.ms-powerpoint.slideshow.macroEnabled.12":
    case "application/vnd.ms-powerpoint":
    case "application/msword":
    case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
    case "application/vnd.openxmlformats-officedocument.wordprocessingml.template":
    case "application/vnd.ms-word.template.macroEnabled.12":
    case "application/vnd.google-apps.document":
    case "application/vnd.google-apps.presentation":
      return true;

    case "application/url":
      return String((metadata as any).source_type || "").toUpperCase() === "PDF";

    default:
      return false;
  }
};

// Video content types (uploaded mp4 or supported external providers).
export const hasVideoAnalytics = (metadata: AssetMetadata): boolean => {
  switch (getContentType(metadata)) {
    case "video/mp4":
      return true;

    case "application/url": {
      const provider = (metadata as any).external_video_provider;
      return (
        provider === "youtube" ||
        provider === "vimeo" ||
        provider === "wistia" ||
        provider === "vidyard"
      );
    }

    default:
      return false;
  }
};

// Audio content types.
export const hasAudioAnalytics = (metadata: AssetMetadata): boolean => {
  switch (getContentType(metadata)) {
    case "audio/mp3":
    case "audio/mpeg":
    case "audio/aiff":
    case "audio/flac":
    case "audio/x-aiff":
      return true;

    default:
      return false;
  }
};
